import { OnboardingTodo } from "../Todos.constants";
import { getOnboardingTodoLabel } from "./getOnboardingTodoLabel";

export function getAllOnboardingTodoLabelsForYear(year: number) {
  const keys = Object.keys(OnboardingTodo).filter((key) =>
    isNaN(Number(key))
  ) as Array<keyof typeof OnboardingTodo>;

  return keys.map((key) => getOnboardingTodoLabel(OnboardingTodo[key], year));
}
